import React, { useState, useRef, useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import apiAuth from "../../helpers/ApiAuth";
import API from "../../../helpers/API";
import NewFooter from "../../../Layouts/NewFooter";
import NewHeader from "../../../Layouts/NewHeader";
import { apiError, loginUser } from "../../../store/actions";
import { trimStart, toLower } from "lodash";
import NotificationManager from "../../../components/Common/NotificationManager";

const Login = (props) => {
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const { Login } = useSelector((state) => state);
  console.log("dataaaa", Login?.loading);
  const { logError } = useSelector((state) => ({
    logError: state.Login.error,
  }));
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (logError) {
      NotificationManager.error("", logError, 3000, null, null, "");
      dispatch(apiError(""));
    }
  }, [logError]);

  const validateEmail = (value) => {
    let error;
    if (!value) {
      error = "Please enter your email address";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };

  const validatePassword = (value) => {
    let error;
    let regExp = new RegExp(
      "^(?=.*\\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$"
    );

    if (!value) {
      error = "Please enter your password";
    } else if (value.length < 6) {
      error = "Value must be longer than 5 characters";
    } else if (!regExp.test(value)) {
      error =
        "Password must have at least One Uppercase, One Number, One Lowercase, And One Special Character";
    }

    return error;
  };

  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden"  }}
      >
        <NewHeader />
        {/* <div className="container" style={{ flex: "1" }}> */}
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
        </div>

        <div className="container" style={{ flex: "1", margin: "auto" }}>
          <Grid container style={{placeItems: "center"}}>
            <Grid item lg={9} xs={12} style={{margin: "auto"}}>
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-40px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                <Formik
                  initialValues={{
                    userName: "",
                    password: "",
                  }}
                  validationSchema={Yup.object({
                    userName: Yup.string().required("Required!"),
                    password: Yup.string().required("Required!"),
                  })}
                  onSubmit={(values) => {
                    if (values.userName && values.password)
                      dispatch(loginUser(values, props.history));
                  }}
                >
                  {({ values, errors, touched, setFieldValue }) => (
                    <Form className="av-tooltip tooltip-label-bottom">
                      <Grid container>
                        <Grid item className="mt-2 mb-2" lg={8} xs={12}>
                          <div className="mb-3">
                            <label
                              htmlFor="username"
                              className="form-label"
                              style={{
                                color: "#9e9e9e",
                                fontSize: "14px",
                              }}
                            >
                              Username
                              {/* <span className="text-danger">*</span> */}
                            </label>

                            <Field
                              className="form-control"
                              name="userName"
                              placeholder="Enter your username"
                              // validate={validateEmail()}
                              style={{
                                borderRadius: "0",
                                border: "none",
                                borderBottom: "1px solid #9e9e9e",
                              }}
                              onMouseOver={(e) =>
                                (e.target.style.borderColor = "#26a69a")
                              }
                              onMouseOut={(e) =>
                                (e.target.style.borderColor = "#9e9e9e")
                              }
                              onClick={(e) =>
                                (e.target.style.borderColor = "#26a69a")
                              }
                            />

                            <ErrorMessage
                              name="userName"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                          <div className="mb-3">
                            <label
                              htmlFor="username"
                              className="form-label"
                              style={{
                                color: "#9e9e9e",
                                fontSize: "14px",
                              }}
                            >
                              Password
                              {/* <span className="text-danger">*</span> */}
                            </label>
                            <div className="position-relative auth-pass-inputgroup">
                              <Field
                                className="form-control"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                // validate={validatePassword}
                                placeholder="Enter your password"
                                style={{
                                  borderRadius: "0",
                                  border: "none",
                                  borderBottom: "1px solid #9e9e9e",
                                }}
                                onMouseOver={(e) =>
                                  (e.target.style.borderColor = "#26a69a")
                                }
                                onMouseOut={(e) =>
                                  (e.target.style.borderColor = "#9e9e9e")
                                }
                                onClick={(e) =>
                                  (e.target.style.borderColor = "#26a69a")
                                }
                              />
                              <div
                                className={[
                                  "btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted",
                                ].join(" ")}
                                onClick={(e) => {
                                  setShowPassword((prev) => !prev);
                                }}
                                id="password-addon"
                              >
                                <i
                                  className={[
                                    showPassword
                                      ? "ri-eye-close-line"
                                      : "ri-eye-fill",
                                    "align-middle",
                                  ].join(" ")}
                                ></i>
                              </div>
                            </div>
                            <ErrorMessage
                              name="password"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                          <div className="mb-3">
                            {Login?.loading ? (
                              <div
                                className="spinner-border"
                                role="status"
                                style={{ color: "rgba(40, 40, 40, 0.8)" }}
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              <div className="mt-4 mb-3">
                                <Button
                                  className="btn my-2 w-100"
                                  type="submit"
                                  style={{
                                    color: "white",
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    background:
                                      "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                                    borderRadius: "5px",
                                    boxShadow:
                                      "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  Login
                                </Button>
                              </div>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </div>
            </Grid>
          </Grid>
        </div>
        {/* </div> */}
        <NewFooter />
      </div>
    </>
  );
};

export default Login;
